// zh.js
export default {
    route: {
        success: "成功",
        languageSwitched: "切换成功！",
        niuhui: "纽辉供应链",
        about: "关于我们",
        about_jj: "纽辉简介",
        about_story: "纽辉故事",
        about_fc: "纽辉风采",
        productList: "产品列表",
        joinMe: "加入我们",
        values_1: "正直",
        values_2: "合作",
        values_3: "创新",
        values_4: "进取",
        employees: "员工数量",
        brands: "品牌数量",
        serveCountry: "服务国家",
        patents: "专利数量",
        developmentHistory: "发展历程",
        product: "产品列表",
        niuhuiStoryT: "纽辉故事",
        niuhuiStoryC: "纽辉人自己的亲历之路",
        productListP: "请输入产品名称、SKU 或分类...",
        briefIntroduction_1: "广州纽辉供应链有限公司始创于2013年，团队创始人均为85后，曾供职于腾讯、恒大等多个国际知名企业；后励精图治，投身创业大潮，核心人员专注于电商行业，深耕多年，与时俱进。",
        briefIntroduction_2: "纽辉成立近十载，团队超百人，在发展过程中几经坎坷，但始终精诚团结，逐步做大做强，\n" +
            "目前扎根于跨境电商行业，销售渠道遍布欧洲、北美、日本等多个发达国家，同时也在深挖各类新兴跨境电商平台，旗下以箱包产品为主的各品牌产品，已经昂首阔步走向全球。同时公司逐步确立了进一步发展壮大的战略目标：",
        briefIntroduction_3: "我们的使命是——创造生活的实用美",
        briefIntroduction_4: "我们的愿景是——成为全球知名箱包品牌",
        briefIntroduction_5: "我们的核心价值观是——正直、合作、创新、进取",
        briefIntroduction_6: "在逐步完善公司的研发、生产、销售全产业链体系的过程中，我们也在不断塑新品牌价值，\n" +
            "打造品牌形象，力争以核心品牌箱包为发端，将来自中国智造的“实用美”传递至世界的每个角落。",
        briefIntroduction_7: "纽辉始终坚信“以人为本，与国同梦”，愿与你携手共进，驰骋全球！",
    }
}
